import React from 'react';
import styles from './CategoryTabs.module.css';

function CategoryTabs({ categories, selectedCategory, onSelectCategory }) {
  return (
    <div className={styles.categoryTabs}>
      {categories.map(category => (
        <button
          key={category.value}
          className={`${styles.categoryTab} ${selectedCategory === category.value ? styles.active : ''}`}
          onClick={() => {

            if (category.value === 'all') {
              onSelectCategory('all');
            } 

            else if (selectedCategory === category.value) {

              onSelectCategory('all');
            } 
            else {
              onSelectCategory(category.value);
            }
          }}
        >
          {category.label}
        </button>
      ))}
    </div>
  );
}

export default CategoryTabs;